import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Input, Button, notification } from 'antd';
import Head from '../../components/Head';
import './auth.css';

function ForgotPassword() {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleEmailSubmit = async (values) => {
    try {
      const response = await fetch(global.SERVIP + '/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: values.email }),
      });
      if (!response.ok) throw new Error();
      const data = await response.json();
      if (data.ok) {
        notification.success({ message: 'Check your email for reset instructions. Don\u2019t forget to check spam.' });
        navigate('/signin');
      } else {
        notification.error({ message: data.message });
      }
    } catch {
      notification.error({ message: 'Something went wrong. Please try again.' });
    }
  };

  return (
    <div className="auth-page">
      <Head title="Forgot Password" />

      <div className="auth-left">
        <Link to="/" className="auth-left-logo">
          <img src="/assets/img/logo/logo2.png" alt="TextLink" />
          <span>TextLink</span>
        </Link>

        <div className="auth-left-content">
          <h2 className="auth-left-tagline">
            Reset your password.
            <span>We'll send you a link.</span>
          </h2>
          <p className="auth-left-desc">
            Enter the email address associated with your account and we'll send you instructions to reset your password.
          </p>
        </div>

        <div className="auth-left-stats">
          <div className="auth-stat">
            <div className="auth-stat-value">10M+</div>
            <div className="auth-stat-label">Messages sent</div>
          </div>
          <div className="auth-stat">
            <div className="auth-stat-value">1,000+</div>
            <div className="auth-stat-label">Active users</div>
          </div>
          <div className="auth-stat">
            <div className="auth-stat-value">95%</div>
            <div className="auth-stat-label">Cheaper than Twilio</div>
          </div>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-form-container">
          <h1 className="auth-heading">Forgot password?</h1>
          <p className="auth-subheading">Enter your email and we'll send you a reset link</p>

          <Form name="forgotPassword" form={form} onFinish={handleEmailSubmit} layout="vertical">
            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                { required: true, message: 'Please enter your email' },
                { type: 'email', message: 'Please enter a valid email' },
              ]}
            >
              <Input placeholder="name@example.com" autoCapitalize="none" />
            </Form.Item>

            <Form.Item>
              <Button htmlType="submit" type="primary" size="large" style={{ width: '100%' }}>
                Send Reset Link
              </Button>
            </Form.Item>
          </Form>

          <p className="auth-footer">
            Remember your password? <a href="/signin">Sign in</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
